import { Component, inject, Inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatError, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { FormControl, FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { ModifyNameDialogModel } from '../../../interfaces/dialogs/modify-name-dialog.model';
import { ModifyNameDialogService } from '../../../services/modify-name-dialog.service';
import { NgClass } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { nameValidator } from '../../../utils/validator.util';

/**
 * 會員中心修改姓名dialog
 */
@Component({
  selector: 'app-modify-name-dialog',
  standalone: true,
  imports: [
    TranslatePipe,
    MatInput,
    MatButton,
    FormsModule,
    MatError,
    MatDialogContent,
    NgClass,
  ],
  templateUrl: './modify-name-dialog.component.html',
  styleUrl: './modify-name-dialog.component.scss',
})
export class ModifyNameDialogComponent {
  translateService: TranslateService = inject(TranslateService);
  modifyNameDialogService: ModifyNameDialogService = inject(
    ModifyNameDialogService
  );
  toastr: ToastrService = inject(ToastrService);
  name: string = ''; // 姓名
  showError: boolean = false; // 是否顯示錯誤訊息
  validationErrors: any = null; // 儲存驗證錯誤

  nameMaxLength: number = 30; // 姓名最大長度

  constructor(
    public dialogRef: MatDialogRef<ModifyNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModifyNameDialogModel
  ) {}

  // 修改姓名
  modifyName() {
    this.showError = true;
    const nameControl = new FormControl(this.name);

    this.validationErrors = nameValidator(nameControl, this.translateService, this.nameMaxLength);

    if (this.name.trim().length > 0 && !this.validationErrors) {
      const req = {
        ...this.data,
        name: this.name,
      };
      this.modifyNameDialogService.modifyName(req).subscribe({
        next: (res) => {
          this.toastr.success(
            this.translateService.instant('modify-name-dialog.modify-success')
          );
          this.dialogRef.close(res.data?.name);
        },
        error: (error) => {
          console.error('修改姓名失敗:', error);
          this.toastr.error(
            this.translateService.instant('modify-name-dialog.modify-error')
          );
          this.dialogRef.close();
        }
      });
    } else {
      this.showError = true;
    }
  }

  // 關閉dialog
  closeDialog() {
    this.dialogRef.close();
  }
}
